import type { Serializable, SerializedModelPayload, UnknownObject } from '~/shared/interfaces'
import { isUnknownObject } from '~/shared/utils/guards'

export interface ModelConstructor<T extends BaseModel = BaseModel> {
  new (data?: unknown): T
  readonly constructorName: string
}

declare module '@vue/reactivity' {
  interface RefUnwrapBailTypes {
    baseModel: BaseModel
  }
}

export default class BaseModel implements Serializable {
  static readonly constructorName: string = ''

  declare readonly ['constructor']: ModelConstructor<this>

  protected readonly rawData: UnknownObject

  constructor(data?: unknown) {
    this.rawData = isUnknownObject(data) ? data : {}
  }

  serialize(): SerializedModelPayload {
    return {
      constructorName: this.constructor.constructorName,
      data: this.rawData,
    }
  }
}
